import {
  Box,
  Center,
  SimpleGrid,
  Text
} from "@chakra-ui/react";
import Lang from "../../Lang";

export default function ImpactBlock({ image, title, text1, text2 }) {
  return (
    <Center>
      <Box
        my={{  md: 10, xl: 10 }}
        w={{ base: "full", md: "8xl", xl: "8xl" }}
      >
        <SimpleGrid
          columns={{ base: 1, md: 2, xl: 2 }}
        >
          <Box
            bgImage={image}
            backgroundSize={"cover"}
            backgroundPosition={"center"}
            w={"full"}
            minH={{base:"300px" , md:"390px"}}
            borderRadius={50}
            px={{ base: 10, md: 5, xl: 5 }}
          ></Box>

          <Box >
            <Text
              as="h2"
              fontWeight={"bold"}
              fontSize={{ base: "2.5em", md: "3.5em", xl: "3.5em" }}
              px={{ base: "10px", md: "80px", xl: "80px" }}
              py={{ base: "20px" }}
            >
              <Lang text={title} />
            </Text>

            <Text
              fontSize={{ base: "1.3em", md: "1.5em", lg:"1.7em", xl: "2em" }}
              pl={{ base: "10px", md: "80px", xl: "80px" }}
              pr={{base:"10px"}}
              mt={2}
            >
              <Lang text={text1} />
            </Text>

            <Text
              fontSize={{ base: "1.3em", md: "1.5em", lg:"1.7em", xl: "2em" }}
              pl={{ base: "10px", md: "80px", xl: "80px" }}
              pr={{base:"10px"}}
              mt={4}
            >
              <Lang text={text2} />
            </Text>

          </Box>

        </SimpleGrid>
      </Box>
    </Center>
  );
}